import { Spin } from "antd";

import GoogleLogo from "@assets/icons/googleLogo";
import FacebookLogo from "@assets/icons/logoFacebook";
import PlusIcon from "@assets/icons/plus";
import { SocialAccount } from "@components/SocialAccount";
import { useProfile } from "@hooks/useProfile";
import { useTitle } from "@hooks/useTitle";
import styles from "./styles.module.scss";
import { EditProfile } from "./ui/EditProfile";
import { NotificationPreferences } from "./ui/NotificationPreferences";
import { useState } from "react";
import SubscriptionAlert from "./ui/SubscriptionAlert/SubscriptionAlert";

const TITLE = "My account (setting)";

export const Account: React.FC = () => {
  useTitle(`Nyle - ${TITLE}`);
  const { isLoading, data: profile, isError } = useProfile();
  const [subscriptionEmail, setSubscriptionEmail] = useState(false);

  if (isLoading) {
    return (
      <div className={styles.spinWrapper}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>
        My account <span className={styles.subTitle}> / Settings</span>
      </h2>

      {!subscriptionEmail && (
        <SubscriptionAlert onButtonClick={() => setSubscriptionEmail(true)} />
      )}

      <div className={styles.wrapper}>
        <div className={styles.columnWrapper}>
          <div className={styles.blockWrapper}>
            <h2 className={styles.blockTitle}>Profile info</h2>
            <EditProfile
              disabled={isError}
              email={profile?.email}
              firstName={profile?.first_name}
              lastName={profile?.last_name}
              country={profile?.country?.code}
            />
          </div>

          <div className={styles.blockWrapper}>
            <button className={styles.plusButton}>
              <PlusIcon />
            </button>
            <h2 className={styles.blockTitle}>
              Linked accounts from social networks
            </h2>

            <div className={styles.socialNetworks}>
              <SocialAccount
                logo={<GoogleLogo />}
                title="Google"
                link="https://myaccount.google.com"
              />

              <SocialAccount
                logo={<FacebookLogo />}
                title="Facebook"
                link="https://myaccount.facebook.com"
              />
            </div>
          </div>
        </div>

        <div className={styles.blockWrapper}>
          <h2 className={styles.blockTitle}>Notification preferences</h2>
          <NotificationPreferences
            subscriptionActive={subscriptionEmail}
            onButtonClick={() => setSubscriptionEmail((prev) => !prev)}
          />
        </div>
      </div>
    </div>
  );
};
